<script>
  import { onMount } from "svelte";
  import request from 'superagent';
  import { createEventDispatcher } from 'svelte';
  
  const dispatch = createEventDispatcher();
  const defaultFeed = {uri: "", name: "", format: "youtube", xpath: "", tag_ids: []}
  
  export let form_id = window.FEED_USAGE_FORM_ID;
  
  export let feed = Object.assign({}, defaultFeed);
  export let show_label = true;
  
  function commit() {
    if (feed.uri == "")
      return;
    let submit = request.post;
    submit(`/forg/${form_id}`)
    .send(feed)
    .then(resp => {
      feed = Object.assign(feed, {
        id: resp.body.feed_id,
        name: resp.body.feed_name
      })
      dispatch('feed', feed)
    });
  }
  
  function cancel() {
    dispatch('cancel');
  }
  
  onMount(() => {
    feed = Object.assign({}, defaultFeed, feed);
  });
</script>
<form action='/form/{form_id}'>
{#if show_label}
<div class='row'>
<div class='col-12'>
<label class='form-text text-muted' for='item-feed-uri'>Odkaz</label>
</div>
</div>
{/if}
<div class='row item-link'>
<fieldset class='form-group col-12'>
<input bind:value='{feed.uri}' class='form-control w-100 underline-input' id='item-link-uri' on:blur='{() => commit()}' placeholder='Adresa YouTube kanálu' rows='3' type='text'>
</fieldset>
</div>
</form>
